// extracted by mini-css-extract-plugin
module.exports = {"header-group":"headerGroup__header-group3PR","padding-top":"headerGroup__padding-top2bS"};